import {
  type NetSalesActionTypes,
  NetSalesTypeKeys,
} from "actions/reports/net_sales";
import type IReportsState from "types/reports";
import { RequestStatus } from "types/request";

const initialState: IReportsState = {
  netSales: [],
  netSalesRequestStatus: RequestStatus.NOT_STARTED,
};

function reports(
  state: IReportsState = initialState,
  action: NetSalesActionTypes
): IReportsState {
  switch (action.type) {
    case NetSalesTypeKeys.RECEIVE_NET_SALES_DATA:
      return {
        ...state,
        netSales: action.netSales,
        netSalesRequestStatus: action.netSalesRequestStatus,
      };

    case NetSalesTypeKeys.REQUEST_NET_SALES_DATA:
      return {
        ...state,
        netSalesRequestStatus: action.netSalesRequestStatus,
      };

    default:
      return state;
  }
}

export default reports;
